import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import request from '../../../utils/Request.utils';

const FAQ_TITLE_MAX_LENGTH = 100;
const FAQ_CONTENT_MAX_LENGTH = 1000;
const limitFaqTitle = (value) => String(value || '').slice(0, FAQ_TITLE_MAX_LENGTH);
const limitFaqContent = (value) => String(value || '').slice(0, FAQ_CONTENT_MAX_LENGTH);
const getFaqTextCount = (value, maxLength) => `${value.length.toLocaleString()} / ${maxLength.toLocaleString()}자`;
/*
const getCategoryLabel = (category) => {
  const categoryName = category.code_nm_kr || category.code_nm || category.comm_code;
  return /^\d+$/.test(String(categoryName)) ? `분류 ${categoryName}` : categoryName;
};
*/
const FaqWrite = () => {
  const navigate = useNavigate();
  const { board_seq } = useParams();

  // const uploadInput = useRef();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [category, setCategory] = useState("");
  //const [categoryList, setCategoryList] = useState([]);

  /*
  useEffect(() => {
    const getCategoryList = () => {
      request.get("/common/code/board_title_ty", {}, (response) => {
        if (response.messageCode === 200) {
          setCategoryList(response.data.data_list);
        } else {
          toast.error("분류 정보를 불러올 수 없습니다.");
        }
      }, () => {
        toast.error("분류 정보를 불러올 수 없습니다.");
      });
    };

    getCategoryList();
  }, []);
  */

  useEffect(() => {
    if (board_seq) {
      // Fetch existing board data
      const fetchBoardData = async () => {
        const formData = new FormData();
        formData.append("board_seq", board_seq);

        try {
          const successHandler = (response) => {
            const data = response.data;
            setTitle(limitFaqTitle(data.board_title));
            setContent(limitFaqContent(data.board_content || data.board_content2 || ""));
            setCategory(data.board_cate || "");
          };

          const errorHandler = (error) => {
            toast.error("FAQ 불러오기 중 오류가 발생했습니다.");
          };

          await request.get(`/board/list/admin/BD_FAQ/${board_seq}`, formData, successHandler, errorHandler);
        } catch (error) {
          toast.error("FAQ 불러오기 중 오류가 발생했습니다.");
        }
      };

      fetchBoardData();
    }
  }, [board_seq]);

  const handleTitleChange = (e) => setTitle(limitFaqTitle(e.target.value));
  const handleContentChange = (e) => setContent(limitFaqContent(e.target.value));
  //const handleCategoryChange = (e) => setCategory(e.target.value);

  const handleSubmit = async () => {
    const trimmedTitle = title.trim();
    const trimmedContent = content.trim();

    if (!trimmedTitle) {
      toast.error("질문을 입력해 주세요.");
      return;
    }

    if (!trimmedContent) {
      toast.error("답변을 입력해 주세요.");
      return;
    }

    if (title.length > FAQ_TITLE_MAX_LENGTH || content.length > FAQ_CONTENT_MAX_LENGTH) {
      toast.error(`질문은 ${FAQ_TITLE_MAX_LENGTH.toLocaleString()}자, 답변은 ${FAQ_CONTENT_MAX_LENGTH.toLocaleString()}자 이하로 입력해 주세요.`);
      return;
    }

    const formData = new FormData();
    formData.append("board_title", trimmedTitle);
    formData.append("board_content", trimmedContent);
    if (category) {
      formData.append("board_cate", category);
    }

    // if (uploadInput.current.files[0]) {
    //   formData.append("image", uploadInput.current.files[0]);
    // }

    try {
      const successHandler = (response) => {
        if (response.messageCode === 200) {
          toast.success(`FAQ가 성공적으로 ${board_seq ? "수정" : "등록"}되었습니다.`);
          navigate("/Board/Faq");
        } else {
          toast.error(`FAQ ${board_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
        }
      };

      const errorHandler = (error) => {
        toast.error(`FAQ ${board_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
      };

      if (board_seq) {
        await request.put(`/board/BD_FAQ/${board_seq}`, formData, successHandler, errorHandler);
      } else {
        await request.put("/board/BD_FAQ", formData, successHandler, errorHandler);
      }

    } catch (error) {
      toast.error(`FAQ ${board_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
    }
  };

  return (
    <main>
      <h2 className="adm_com_pg_tit">FAQ {board_seq ? "수정" : "등록"}</h2>
      <div className="adm_com_pg_content">
        <table className='adm_com_board_list type_row'>
          <colgroup>
            <col width="10%" /><col />
            <col width="10%" /><col />
          </colgroup>
          <tbody>
            {/*
            <tr>
              <th>분류</th>
              <td colSpan={3}>
                <select className="select ws" value={category} onChange={handleCategoryChange}>
                  <option value="">선택</option>
                  {categoryList.map((category) => (
                    <option key={category.comm_code} value={category.comm_code}>
                      {getCategoryLabel(category)}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            */}
            <tr>
              <th>질문</th>
              <td colSpan={3}>
                <input
                  type="text"
                  className="input"
                  value={title}
                  onChange={handleTitleChange}
                  maxLength={FAQ_TITLE_MAX_LENGTH}
                />
                <p className="adm_char_count">{getFaqTextCount(title, FAQ_TITLE_MAX_LENGTH)}</p>
              </td>
            </tr>
            <tr>
              <th>답변</th>
              <td colSpan={3}>
                <textarea
                  className="textarea"
                  value={content}
                  onChange={handleContentChange}
                  rows="10"
                  maxLength={FAQ_CONTENT_MAX_LENGTH}
                />
                <p className="adm_char_count">{getFaqTextCount(content, FAQ_CONTENT_MAX_LENGTH)}</p>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="adm_com_btn_wrap center">
          <button className="adm_com_btn blue" onClick={handleSubmit}>{board_seq ? "수정" : "등록"}</button>
          <button className="adm_com_btn gray" onClick={() => navigate("/Board/Faq")}>취소</button>
        </div>
      </div>
      <ToastContainer />
    </main>
  );
};

export default FaqWrite;
